import React from "react";
import { Table } from "react-bootstrap";
import moment from "moment";

export const LEAVE_LABELS = {
    sickLeave: "Sick Leave",
    vacationLeave: "Vacation Leave",
    losLeave: "LOS Leave",
    withoutPay: "Without Pay",
    mixed: "Multiple leave types",
};

export default function LeaveAllocationSummary({ allocations = [], days = [] }) {
    if (!allocations.length) return null;
    return (
        <div>
            <h5>Leave allocations</h5>
            <ul>
                {allocations.map((row, index) => (
                    <li key={index}>{LEAVE_LABELS[row.leaveType] || row.leaveType}: {row.days} day(s)</li>
                ))}
            </ul>
            {days.length > 0 && (
                <Table responsive condensed>
                    <thead><tr><th>Date</th><th>Allocation</th><th>Paid days</th><th>Unpaid days</th></tr></thead>
                    <tbody>
                        {days.map(day => (
                            <tr key={day.date}>
                                <td>{moment.utc(day.date).format("MMM D, YYYY")}</td>
                                <td>{(day.sources || []).map(source => `${LEAVE_LABELS[source.leaveType]} (${source.days})`).join(", ")}</td>
                                <td>{day.paidDays}</td><td>{day.withoutPayDays}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </div>
    );
}
